import styled from 'styled-components';
import {dFlex, dFlexCenter} from '../../../../globalVariables/GlobalVariables';

export const row = styled.div`
    ${dFlex};
    align-items: stretch;
    background: var(--TA-color-bg-base);
`;

export const timeLabel = styled.div`
    width: 60px;
    flex-shrink: 0;
    box-sizing: border-box;
    background: var(--TA-color-bg-surface-default);
    ${dFlexCenter};
    padding: 6px 16px;
    color: var(--TA-color-text-subtle);
    font-size: var(--font-size-caption);
    font-weight: var(--font-weight-medium);
    line-height: 18px;
`;
